import React, { useRef, useState} from "react";
import Button from "react-bootstrap/Button";
import axios from "axios";
import apiUrl from "../../shared/config";
import {Edit, RemoveCircleOutline, ThumbDown, ThumbsUpDown, ThumbUp, VisibilityOff} from "@material-ui/icons";
import Moment from "react-moment";
import Form from "react-bootstrap/Form";
import SubmitCommentButton from "./SubmitCommentButton";
import Popover from "react-bootstrap/Popover";
import PersonRounded from "@material-ui/icons/PersonRounded";
import {Tooltip} from "@material-ui/core";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {useDispatch, useSelector} from "react-redux";
import * as actionTypes from "../../store/actions/actionTypes";
import {AnimatePresence, motion} from "framer-motion"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PresetModal from "../UI/Modal/PresetModal/PresetModal";
import {findAssessment} from "../../utils/voteUtils";
import Auth from "../../containers/Auth/Auth";


export default function PatternComment({pattern_comment, pattern_id, authorIds, token, updateOnDelete, updateOnEdit, userId}) {
    const [comment, setComment] = useState(pattern_comment.comment + "");
    const [editComment, setEditComment] = useState(false);
    const [showButtons, setShowButtons] = useState(false);
    const [isSuggestedOpen, setIsSuggestedOpen] = useState(false);
    const [isRatingOpen, setIsRatingOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const dispatch = useDispatch();
    const loginModal = useRef();
    const permissions = useSelector(state => state.auth.userPermissions)

    const deleteButtonShown = ((parseInt(userId) === parseInt(pattern_comment.user_id)
            || authorIds.some(authorId => authorId === parseInt(userId))
            || permissions.delete_comment)
        && showButtons)



    const closeSuggestedPopover = () => {
        setIsSuggestedOpen(false);
    };

    const openUserProfile = (userId) => {
        closeSuggestedPopover();
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    const handleDeleteComment = comment_id => {
        const data = {
            pattern_id: pattern_id, comment_id: comment_id, user_id: parseInt(userId)
        };

        axios.post(apiUrl + "Pattern/deleteComment?token=" + token, data)
            .then(response => {
                console.log("Post successful:", response.data);
                updateOnDelete();
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    }

    function sendVote(vote, comment_id) {
        if (token) {
            axios.get(apiUrl + "Vote/vote?token=" + token + "&primary_id=" + pattern_id + "&secondary_id=" + comment_id + "&vote=" + vote + '&vote_type=COMMENT')
                .then(updateOnEdit).then(() => {
                if (isRatingOpen) {
                    window.scrollTo(window.scrollX, window.scrollY);
                }
            }).catch(() => console.log("Vote Failed"));
        } else {
            setIsRatingOpen(false);
            loginModal.current.open();
        }
    }

    function getAssessment(up, down) {
        const totalVotes = up + down;
        const percent = (up / totalVotes) * 100;

        return totalVotes === 0 ? { assess: "None", color: "gray" } : findAssessment(percent, totalVotes);
    }

    const assess = getAssessment(pattern_comment.up_votes, pattern_comment.down_votes);

    const getComment = () => {return comment}

    const delete_comment_button = (<AnimatePresence>{deleteButtonShown &&
        <motion.div
            initial={{opacity: 0, x: 15}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: 15}}
            transition={{duration: 0.5, ease: "easeInOut"}}
        >
            <OverlayTrigger
                trigger="click"
                rootClose
                placement="bottom"
                show={isDeleteOpen} // Control visibility with state
                onToggle={() => setIsDeleteOpen(false)} // Toggle state on click
                overlay={
                    <Popover id="pattern-game-description">
                        <Popover.Content className="game-description">
                            Are you sure you want to delete this comment?
                            <Button
                                onClick={() => handleDeleteComment(pattern_comment.comment_id)}
                                size="sm"
                                variant="primary"
                                type="submit"
                                className="delete-confirm-button"
                            >
                                Delete
                            </Button>
                        </Popover.Content>
                    </Popover>
                }
            >
                <Tooltip title="Delete" placement="top">
                    <RemoveCircleOutline
                        className="delete-icon"
                        onClick={() => setIsDeleteOpen(prev => !prev)} // Toggle popover
                    />
                </Tooltip>
            </OverlayTrigger>
        </motion.div>}</AnimatePresence>)

    const edit_comment_button = (<AnimatePresence>{(parseInt(userId) === parseInt(pattern_comment.user_id) && showButtons) &&
        <motion.div initial={{opacity: 0, x: 15}} animate={{opacity: 1, x: 0}} exit={{opacity: 0, x: 15}}
                    transition={{duration: .5, ease: "easeInOut"}}>
            <Tooltip title={"Edit"} placement="top">
                <Edit
                    onClick={() => setEditComment(!editComment)}
                    className="edit-icon"
                />
            </Tooltip>
        </motion.div>}</AnimatePresence>)

    const user_button = (<AnimatePresence>{showButtons &&
        <motion.div initial={{opacity: 0, x: 15}} animate={{opacity: 1, x: 0}} exit={{opacity: 0, x: 15}}
                    transition={{duration: .5, ease: "easeInOut"}}>
            <OverlayTrigger
                trigger="click"
                rootClose
                rootCloseEvent="click"
                placement='bottom'
                onToggle={() => setIsSuggestedOpen(false)}
                show={isSuggestedOpen}
                overlay={<Popover id='pattern-game-description'>
                    <Popover.Content className="game-description">
                        Suggested By:
                        <span className="example-suggested-link" onClick={() => {
                            openUserProfile(pattern_comment.user_id);
                            closeSuggestedPopover();
                        }}>
                                            <PersonRounded style={{marginTop: -3}}/>{pattern_comment.display_name}
                                        </span>
                    </Popover.Content>
                </Popover>}
            >
                <Tooltip title={"User Profile"} placement="top">
                <PersonRounded className="user-icon" onClick={() => setIsSuggestedOpen(prev => !prev)}/>
            </Tooltip>
        </OverlayTrigger>
        </motion.div>}
        </AnimatePresence>
    );

    const timestamp_text = () => {
        return (<span className="comment-timestamp">
            Posted on <Moment format="M/D/Y, h:mma">{pattern_comment.posted_timestamp}</Moment>.
            {pattern_comment.edited_timestamp !== pattern_comment.posted_timestamp
                ? <React.Fragment> Last edited on <Moment format="M/D/Y, h:mma">{pattern_comment.edited_timestamp}</Moment>.</React.Fragment>
                : ""}
        </span>)
    }

    const edit_buttons = () => {
        return (<React.Fragment>
            <SubmitCommentButton
                update={updateOnEdit}
                userId={userId}
                pattern_id={pattern_id}
                token={token}
                commentId={pattern_comment.comment_id}
                resetComment={() => {
                    if (!getComment()) {
                        setComment(pattern_comment.comment);
                    }
                    setEditComment(false);
                }}
                getComment={getComment()}
                buttonStyle={{marginRight: 10, marginBottom: 10, fontSize: 14}}
                buttonText={"Update"}
            />
            <Button
                onClick={() => {
                    setEditComment(false);
                    setComment(pattern_comment.comment);
                }}
                className="btn-danger btn-edit-comment"
            >
                Cancel
            </Button>
        </React.Fragment>)
    }

    const likeButton = <AnimatePresence> {showButtons && (<Tooltip title="Agree" placement="top">
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <motion.div
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: {type: "spring", stiffness: 300, damping: 10, duration: 0.5}
                    }}
                    style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                >
                    <ThumbUp onClick={() => {
                        sendVote(pattern_comment.user_vote === 1 ? 0 : 1, pattern_comment.comment_id)
                    }} color={pattern_comment.user_vote === 1 ? "inherit" : "action"} style={{
                        width: '20px',
                        height: '20px', marginRight: "4px"
                    }}/>
                </motion.div>
            </motion.div>
        </Tooltip>
    )} </AnimatePresence>;

    const dislikeButton = <AnimatePresence>{showButtons && (<Tooltip title="Disagree" placement="top">
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <motion.div
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: {type: "spring", stiffness: 300, damping: 10, duration: 0.5}
                    }}
                    style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                >
                    <ThumbDown onClick={() => {
                        sendVote(pattern_comment.user_vote === -1 ? 0 : -1, pattern_comment.comment_id)
                    }} color={pattern_comment.user_vote === -1 ? "inherit" : "action"} style={{
                        width: '20px',
                        height: '20px', marginRight: "4px"
                    }}/>
                </motion.div>
            </motion.div>
        </Tooltip>
    )} </AnimatePresence>;

    const ratingButton = <AnimatePresence>{showButtons && (
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <OverlayTrigger
                    trigger="click"
                    rootClose
                    rootCloseEvent="click"
                    placement='bottom'
                    onToggle={() => setIsRatingOpen(false)}
                    show={isRatingOpen}
                    overlay={<Popover id='pattern-game-description'>
                        <Popover.Title>Rate This Comment</Popover.Title>
                        <Popover.Content className="game-description">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", minWidth: "200px"}}>
                                <p style={{ margin: 0, lineHeight: '1.5' }}>{"Total Votes: " + (pattern_comment.up_votes + pattern_comment.down_votes)}</p>
                                <div style={{gap: '5px', justifyContent: "normal"}}>
                                    {likeButton}
                                    {dislikeButton}
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                <span>Assessment:</span>
                                <p style={{ color: assess.color, margin: 0 }}>{assess.assess}</p>
                            </div>
                        </Popover.Content>
                    </Popover>}>
                    <Tooltip title={"Rating"} placement="top">
                    <ThumbsUpDown className="rating-icon" onClick={() => setIsRatingOpen(prev => !prev)}/>
                    </Tooltip>
                </OverlayTrigger>
            </motion.div>
    )} </AnimatePresence>;

    const carrotDest = () => {
        let total = 0;
        showButtons && (total -= 40);
        deleteButtonShown && (total -= 25)
        showButtons && parseInt(userId) === parseInt(pattern_comment.user_id) && (total -= 25)
        return total;
    };

    const carrotToExpand = (
        <motion.div
            key={`expand-carrot-${pattern_comment.comment_id}-${pattern_id}-horizontal`}
            animate={{
                x: carrotDest()
            }}
            style={{position: "absolute", display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
        >
            {pattern_comment.hidden_content
                ? <span style={{color: "#bf8888", fontWeight: "bold", alignItems: "center", display: "flex"}}>
                    Hidden Content
                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    rootClose
                    rootCloseEvent="click"
                    placement='bottom'
                    overlay={
                        <Popover id='hidden-content-info' style={{maxWidth: 1000}}>
                            <Popover.Title as="h3">Hidden Content</Popover.Title>
                            <Popover.Content className="hidden-content">
                                {/*{"This comment is hidden because the commenter doesn't have a shared contact email. "}*/}
                                {parseInt(userId) === parseInt(pattern_comment.user_id)
                                    ? <>This comment is hidden because you don't have a shared contact email.<br/><br/>Add and share a valid contact email to make this comment visible to other users on the site. You can do this by
                                        editing your User Profile, entering a valid contact
                                        email, then click "Display Contact Email."</>
                                    : authorIds.some(authorId => authorId === parseInt(userId)) || permissions.delete_comment
                                        ? <React.Fragment>{"This comment is hidden because the commenter doesn't have a shared contact email.\n\nTo make this comment visible, users who "}
                                            {authorIds.some(authorId => authorId === parseInt(userId)) ? "are pattern authors " : ""}
                                            {authorIds.some(authorId => authorId === parseInt(userId)) && permissions.delete_comment ? "or " : ""}
                                            {permissions.delete_comment ? "have permission to delete comments " : ""}
                                            {"can verify this comment by liking it. \n\nFirst, make sure " +
                                                "you have a valid contact email and check \"Display Contact Email\" " +
                                                "in your User Profile. Then, like this game to verify it. \n\n"}
                                            <i>This comment will remain verified until it is edited by a user
                                                without a shared contact email.</i>
                                        </React.Fragment>
                                        : ""}
                            </Popover.Content>
                        </Popover>
                    }
                >
                    <VisibilityOff style={{transform: "scale(0.9)", marginLeft: 3}}/>
                </OverlayTrigger>
            </span>
                : ''}
            <motion.div
                key={`expand-carrot-${pattern_comment.comment}-${pattern_id}-rotate`}
                animate={{
                    rotate: showButtons ? 90 : -90,
                }}
                onClick={() => setShowButtons(prev => !prev)}
                style={{display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
            >
                <ExpandMoreIcon/>
            </motion.div>
        </motion.div>
    );

    return (
        <><div key={pattern_comment.comment_id} className="comment-box" style={pattern_comment.hidden_content ? {border:  "2px solid #bf8888"} : {}}>
            <dt
                className="comment-header"
                style={pattern_comment.hidden_content ? {borderBottom:  "2px solid #bf8888"} : {}}
            >

                    <div className="comment-title"><b className="left-box">{pattern_comment.display_name}</b>
                    <div className="right-box" style={pattern_comment.hidden_content ? {minWidth: -1 * carrotDest() + 165} : {minWidth: -1 * carrotDest() + 20}}>
                        {user_button}
                        {edit_comment_button}
                        {delete_comment_button}
                        {ratingButton}
                        {carrotToExpand}
                    </div>
                    </div>

            </dt>
            {!editComment
                ? <dd className="comment-body">{pattern_comment.comment}</dd>
                : <React.Fragment>
                    <dd className="comment-editor">
                        <Form.Control
                            as="textarea"
                            rows="4"
                            placeholder="Edit your comment"
                            style={{height: "64px"}}
                            value={comment}
                            onChange={(event) => setComment(event.target.value)}
                        />
                    </dd>
                </React.Fragment>}
            <dd className="comment-timestamp">
                {!editComment ? timestamp_text() : edit_buttons()}
            </dd>
    </div>
            <PresetModal ref={loginModal} title={"Login To Rate A Comment"}><Auth shouldRedirect hideDragon/></PresetModal>
        </>);
}
